import { HttpErrorResponse } from '@angular/common/http';

export type GatewayAlertSeverity = 'error' | 'warning';

/**
 * Clasifica el status HTTP para AlertService.error vs .warn.
 * 5xx y 0 (red) se tratan como error fuerte; 4xx de validación/permiso como advertencia.
 */
export function gatewayHttpErrorSeverity(status: number | undefined): GatewayAlertSeverity {
  if (status == null || status === 0) {
    return 'error';
  }
  if (status >= 500) {
    return 'error';
  }
  if (status === 401) {
    return 'warning';
  }
  if (status === 400 || status === 403 || status === 423) {
    return 'warning';
  }
  if (status === 502) {
    return 'error';
  }
  if (status >= 400) {
    return 'warning';
  }
  return 'error';
}

function pickMessageBody(body: unknown): string | null {
  if (body == null) {
    return null;
  }
  if (typeof body === 'string') {
    const t = body.trim();
    return t.length ? t : null;
  }
  if (typeof body === 'object') {
    const o = body as Record<string, unknown>;
    const keys = ['message', 'Message', 'error', 'detail', 'title'];
    for (const k of keys) {
      const v = o[k];
      if (typeof v === 'string' && v.trim()) {
        return v.trim();
      }
    }
  }
  return null;
}

/** Texto legible para mostrar al usuario. */
export function gatewayHttpErrorMessage(error: HttpErrorResponse | any): string {
  if (error instanceof HttpErrorResponse) {
    const fromBody = pickMessageBody(error.error);
    if (fromBody) {
      return fromBody;
    }
    if (error.message) {
      return error.message;
    }
    if (error.statusText) {
      return `${error.status} ${error.statusText}`.trim();
    }
  }
  if (error && typeof error.message === 'string') {
    return error.message;
  }
  return 'Error de comunicación con el servidor.';
}
